import RegionRenderer from 'app/components/BasicTable/CellRenderers/RegionRenderer';
import { TFunction } from 'i18next';
import { translations } from 'locales/translations';
import { Column } from 'react-table';
import { GlobalSettings } from 'utils/globalSettings';
import { IRegionDto } from '../IRegionDto';

export const getColumns = (t: TFunction, settings: GlobalSettings) => {
  const cols: Column<IRegionDto>[] = [
    {
      Header: t(translations.Id) as string,
      accessor: 'Id',
      Cell: RegionRenderer,
    },
    {
      Header: t(translations.RegionName) as string,
      accessor: 'Name',
    },
  ];
  return cols;
};
